import useComputed from '@/hooks/use-computed'
import api from '@/services/api/adminApprovalRequest.js'
import { immerable } from "immer"
import { useState } from 'react'

class ApprovalRequests {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.userId = params.userId
		this.requestType = params.requestType
		this.orgId = params.orgId
		this.status = params.status
		this.comment = params.comment
		this.user = params.user
		this.organization = params.organization
		this.orgPersona = params.orgPersona
		this.organizationUseCases = params.organizationUseCases
		this.created = params.created
		this.modified = params.modified
		this.modifiedBy = params.modifiedBy
	}
}


const useApprovalRequest = (_queryParam) => {

	const [itemsApprovalRequests, setItemsApprovalRequests] = useComputed([])
	const [currentItemApprovalRequests ,setCurrentItemApprovalRequests] = useState(null)
	const [metaApprovalRequests, setMetaApprovalRequests] = useState(null)
	const [loadingApprovalRequests, setLoadingApprovalRequests] = useState(false)
	const [errorApprovalRequests, setErrorApprovalRequests] = useState()

	const [reviewCountApprovalRequests, setReviewCountApprovalRequests ] = useState("")
	const [useCaseApprovalRequests, setUseCaseApprovalRequests] = useState({})
	const [personaItems, setPersonaItems] = useState([])



	async function fetchApprovalRequests(parameter) {
		setLoadingApprovalRequests(true)

		const params = parameter ? parameter : "";

		const [errorReponse, dataReponse] = await api.index({
			params
		})

		setLoadingApprovalRequests(false)

		if (errorReponse) {
			return setErrorApprovalRequests(errorReponse)
		}

		const { meta } = dataReponse

		if (!Array.isArray(dataReponse.admin_requests)) {
			return setErrorApprovalRequests('Request is not an array')
		}

		const serializedData = dataReponse.admin_requests.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new ApprovalRequests(data))
		setMetaApprovalRequests(meta)
		return setItemsApprovalRequests(newItems)

	}

	async function findApprovalRequests(parameter) {
		setLoadingApprovalRequests(true)

		const params = parameter ? parameter : "";

		const [errorReponse, dataReponse] = await api.getRequest(params)
		const dataArray = [dataReponse]

		setLoadingApprovalRequests(false)

		if (errorReponse) {
			return setErrorApprovalRequests(errorReponse)
		}

		const serializedData = dataArray.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new ApprovalRequests(data))
		const persona = newItems[0].orgPersona?.map(item => ({ id:item.persona.personaId, name:item.persona.personaName, $selected: true }))
		setPersonaItems(persona)
		setUseCaseApprovalRequests(newItems[0]?.orgPersona[0]?.useCase)
		setCurrentItemApprovalRequests(newItems[0])
	}

	async function getRequestCountApprovalRequests(parameter) {
		setLoadingApprovalRequests(true)

		const params = parameter ? parameter : "";

		const [errorReponse, dataReponse] = await api.index({
			params
		})

		setLoadingApprovalRequests(false)

		if (errorReponse) {
			return setErrorApprovalRequests(errorReponse)
		}

		const { meta } = dataReponse
		setReviewCountApprovalRequests(meta.total)
	}


	function serialize(entry) {
		return {
			created: entry.created,
			modified: entry.modified,
			modifiedBy: entry.modifiedBy,
			id: entry.id,
			userId: entry.userId,
			requestType: entry.requestType,
			organization: entry.organization,
			orgId: entry.orgId,
			status: entry.status,
			comment: entry.comment,
			user: entry.user,
			orgPersona: entry.orgPersona,
			organizationUseCases: entry.organizationUseCases,
		}
	}

	function viewApprovalRequests(id) {
		const newCurrentItem = itemsApprovalRequests.find(item => item.id === id)
		setCurrentItemApprovalRequests(newCurrentItem)
	}

	return {
		errorApprovalRequests,
		fetchApprovalRequests,
		itemsApprovalRequests,
		currentItemApprovalRequests,
		setCurrentItemApprovalRequests,
		loadingApprovalRequests,
		setItemsApprovalRequests,
		viewApprovalRequests,
		findApprovalRequests,
		metaApprovalRequests,
		getRequestCountApprovalRequests,
		reviewCountApprovalRequests,
		useCaseApprovalRequests,
		personaItems,
		setPersonaItems
	}

}

export default useApprovalRequest;
